module.exports = {
	defaultManager: 'tsgo-defaultmanager',
	requestLimit: 'tsgo-requestlimit',
	virtualCardExpRange: 'tsgo-virtualcardexprange',
};
